import {
    FETCH_PLANS,
    SET_PARTNER,
    SELECT_BANK,
    CLEAR_COUPON,
    CLEAR_ALERTS,
    FETCH_ADDRESS,
    SET_COUPON_TEXT,
    FINISH_PURCHASE,
    ADD_INSURED_FORM,
    CHANGE_CASH_ATTR,
    VALIDATE_PURCHASE,
    OPEN_DETAIL_MODAL,
    SET_PURCHASE_UUID,
    FETCH_PAYMENT_INFO,
    CLOSE_DETAIL_MODAL,
    CHANGE_BOLETO_ATTR,
    CHANGE_CONTACT_ATTR,
    FETCH_PURCHASE_DATA,
    REMOVE_INSURED_FORM,
    FETCH_PLANS_PURCHASE,
    SET_QUOTATION_PARAMS,
    OPEN_MODAL_SAFETYPAY,
    END_PURCHASE_LOADING,
    CLOSE_MODAL_SAFETYPAY,
    FETCH_DISCOUNT_COUPON,
    FETCH_PAYMENT_METHODS,
    SELECT_PAYMENT_METHOD,
    CHANGE_SAFETYPAY_ATTR,
    START_PURCHASE_LOADING,
    CHANGE_CREDITCARD_ATTR,
    FETCH_BENEFITS_METHODS,
    SELECT_CREDITCARD_BRAND,
    OPEN_MODAL_TERMS_OF_USE,
    CLOSE_MODAL_TERMS_OF_USE,
    CHANGE_INSURED_FORM_ATTR,
    SELECT_CREDITCARD_PARCEL,
    OPEN_MODAL_PURCHASE_ERROR,
    CLOSE_MODAL_PURCHASE_ERROR,
    OPEN_MODAL_COUPON_ERROR,
    CLOSE_MODAL_COUPON_ERROR,
    OPEN_MODAL_PURCHASE_DATE_ERROR,
    CLOSE_MODAL_PURCHASE_DATE_ERROR,
    OPEN_MODAL_GENERIC_ERROR,
    CLOSE_MODAL_GENERIC_ERROR,
    OPEN_MODAL_FRANCHISE,
    CLOSE_MODAL_FRANCHISE,
    OPEN_MODAL_OPERATOR_CONFIRMATION,
    CLOSE_MODAL_OPERATOR_CONFIRMATION,
    OPEN_MODAL_STUDENT,
    CLOSE_MODAL_STUDENT,
    SET_USER_DETAILS,
    CHANGE_CONFIRM_TERMS,
    SHOW_INVALID_CREDIT_CARD_ERROR,
    CLEAN_ERRORS,
    NEXT_STAGE_PURCHASE_MOBILE,
    STAGE_PAYMENT_CREDIT_CARD,
    STAGE_PAYMENT_CASH_TRANSFER,
    EDIT_PURCHASE,
    BACK_STAGE_PURCHASE,
    SELECT_PAYMENT_ALTER_STATE,
    BACK_STAGE_PAYMENT_METHOD,
    CLEAN_STATES_PURCHASE_MOBILE,
    VALIDATOR_HANDLER_BLUR,
    GET_INFOS_PROSPECT,
    CLEAR_INFOS_PROSPECT,
    GET_INFOS_INSUREDS,
    SET_INFOS_PROSPECT_IN_PURCHASE,
    OPEN_MODAL_TRAVEL_RENEWAL,
    CLOSE_MODAL_TRAVEL_RENEWAL,
    OPEN_MODAL_RENEWAL_FRANCHISE,
    CLOSE_MODAL_RENEWAL_FRANCHISE,
    OPEN_MODAL_RECEPTIVE_PRODUCT,
    OPEN_MODAL_PLAN_RULES,
    CLOSE_MODAL_PLAN_RULES,
    CLOSE_MODAL_RECEPTIVE_PRODUCT,
    HIDE_INVALID_CREDIT_CARD_ERROR,
    CHANGE_PIX_ATTR,
    OPEN_MODAL_NOT_COVID_COVERAGE,
    CLOSE_MODAL_NOT_COVID_COVERAGE,
    SET_BENEFITS,
    PURCHASE_GET_PAYMENT_METHODS,
    OPEN_MODAL_FAIL_PAYMENT,
    CLOSE_MODAL_FAIL_PAYMENT,
    SET_OPERATOR_CONFIRMATION_CLICKED,
    SET_UPSELL_PURCHASE,
    FETCH_FIRST_ACTIVE_CREDIT_COUPON_ERROR,
    FETCH_FIRST_ACTIVE_CREDIT_COUPON_SUCCESS,
    SET_CREDIT_COUPON_CODE_TEXT,
    APPLY_CREDIT_COUPON_SUCCESS,
    APPLY_CREDIT_COUPON_ERROR,
    REMOVE_APPLIED_CREDIT_COUPON,
} from '../actions/actionTypes';

import {
    updatePurchaseSummaryData,
    validatePurchase,
    validatePurchaseMobile,
    formatDate,
    removeCookie,
    cleanStateErrors,
    validatePurchaseOnBlur,
    isSelected,
    normalizePaymentMethodsName,
} from '../utils'

import { checkoutPurchase } from '../apiCalls';

import matomoTracker from '../utils/matomo';
import dataLayer from '../utils/dataLayer';


let newState = {};

const calcCreditCard = (state) => {
    if (!state.purchaseSummary || !state.creditCard.baseBrands)
        return { ...state };

    let brands = [...state.creditCard.brands]

    if (!brands.length)
        brands = state.creditCard.baseBrands

    let parcels = [],
        selectedParcelIndex = -1;
    const paymentMethods = [...state.paymentMethods];
    const selectedBrand = brands.filter(brand => brand.selected)[0]

    if (selectedBrand)
        state.creditCard.parcels.forEach(
            (parcel, i) => {
                if (parcel.selected)
                    selectedParcelIndex = i + 1;
            }
        )

    if (selectedBrand) {
        // cálculo das parcelas com base no valor mínimo
        // e quantidade máxima de parcelas
        for (let i = 1; i <= selectedBrand.max_parcels; i += 1) {
            const parcelPrice = state.purchaseSummary.total / i;
            if (parcelPrice >= selectedBrand.min_parcel_value)
                parcels = parcels.concat({
                    times: i,
                    price: (parcelPrice).toFixed(2),
                    selected: (i === selectedParcelIndex)
                })
        }
        if (parcels.length === 0 && state.purchaseSummary.total) {
            parcels = [{ times: 1, price: parseFloat(state.purchaseSummary.total).toFixed(2), selected: true }]
        }
    }

    const newBrands = brands.map(
        (brand) => {
            let maxParcels = Math.floor(state.purchaseSummary.total / brand.min_parcel_value)

            if (state.purchaseSummary.total / brand.min_parcel_value >= brand.max_parcels)
                maxParcels = brand.max_parcels;
            else if (parseFloat(state.purchaseSummary.total) <= brand.min_parcel_value)
                maxParcels = 1;

            return ({
                ...brand,
                parcels: maxParcels,
            })
        }
    );

    return {
        ...state,
        creditCard: {
            ...state.creditCard,
            brands: newBrands,
            parcels
        },
        paymentMethods
    }
}

const setNotAvailableAlert = (state, paymentMethod) => {
    const validDate = new Date().addDays(2) >= Date.parse(state.quotationParams.departure_date)
    const availabilityValidations = !paymentMethod.available && paymentMethod.selected
    const paymentMethodValidations = paymentMethod.slug === 'boleto' || paymentMethod.slug === 'safetypay'

    if (validDate && availabilityValidations && paymentMethodValidations) {
        return {
            ...state,
            alert: paymentMethod.slug,
        }
    }

    return { ...state }
}

const purchase = (state = {}, action) => {
    switch (action.type) {
        case PURCHASE_GET_PAYMENT_METHODS:
            const defaultMethod = state.paymentMethods.find(method => method.selected);

            if (defaultMethod) {
                return {
                    ...state,
                    paymentMethods: state.paymentMethods
                }
            }

            return {
                ...state,
                payments: action.data,
                paymentMethods: state.paymentMethods.map(paymentMethod => {
                    const payment = action.data.find(p => normalizePaymentMethodsName(p.slug) === paymentMethod.slug)
                    if (payment) {
                        return {
                            ...paymentMethod,
                            deadline: payment.deadline,
                            active: payment.active,
                            displayOrder: payment.display_order,
                            selected: isSelected(payment),
                            discount: payment.discount,

                        }
                    }
                    return paymentMethod
                })
            }
        case FETCH_PAYMENT_INFO:
            return {
                ...state,
                paymentInfo: action.paymentInfo
            };

        // #region Coupon
        case SET_COUPON_TEXT:
            return {
                ...state,
                coupon: {
                    text: action.value,
                }
            }

        case FETCH_DISCOUNT_COUPON:
            newState = {
                ...state,
                coupon: {
                    ...state.coupon,
                    ...action.coupon
                }
            };
            return calcCreditCard(
                updatePurchaseSummaryData({
                    ...newState,
                })
            );

        case CLEAR_COUPON:
            newState = {
                ...state,
                coupon: {
                    text: state.coupon.text,
                }
            };

            return calcCreditCard(
                updatePurchaseSummaryData({
                    ...newState,
                })
            );
        // #endregion

        // Credit Coupon
        case FETCH_FIRST_ACTIVE_CREDIT_COUPON_SUCCESS:
          return {
            ...state,
            creditCoupon: {
              ...state.creditCoupon,
              code: action.payload.code,
              creditAmount: action.payload.credit_amount,

            },
          };

        case FETCH_FIRST_ACTIVE_CREDIT_COUPON_ERROR:
          return {
            ...state,
            creditCoupon: {
              ...state.creditCoupon,
              error: action.payload.msg,
            },
          };

        case APPLY_CREDIT_COUPON_SUCCESS:
          newState = {
            ...state,
            creditCoupon: {
              ...state.creditCoupon,
              code: action.payload.code,
              creditAmount: action.payload.credit_amount,
              applied: true,
            },
          };

          return calcCreditCard(updatePurchaseSummaryData({...newState}));

        case APPLY_CREDIT_COUPON_ERROR:
          newState = {
            ...state,
            creditCoupon: {
              ...state.creditCoupon,
              applied: false,
              error: action.payload.msg,
            },
          };

          return calcCreditCard(updatePurchaseSummaryData({...newState}));

        case SET_CREDIT_COUPON_CODE_TEXT:
          return {
            ...state,
            creditCoupon: {
              code: action.value,
              creditAmount: 0.0,
              applied: false,
              error: null,
            }
          }

        case REMOVE_APPLIED_CREDIT_COUPON:
          newState = {
            ...state,
            creditCoupon: {
              ...state.creditCoupon,
              applied: false,
            },
          };

          return calcCreditCard(updatePurchaseSummaryData({...newState}));

        // #region Insured
        case ADD_INSURED_FORM:
            return calcCreditCard(
                updatePurchaseSummaryData({
                    ...state,
                    insuredForms: [
                        ...state.insuredForms,
                        action.form
                    ],
                    errors: {
                        ...state.errors,
                        insuredForms: [
                            ...state.errors.insuredForms,
                            {
                                cpf: false,
                                rg: false,
                                name: false,
                                birth_date: false,
                                incoming: false,
                            }
                        ]
                    },
                    isInsuredFormDeletable: true
                })
            )
        case REMOVE_INSURED_FORM:
            return calcCreditCard(
                updatePurchaseSummaryData({
                    ...state,
                    insuredForms: (state.insuredForms.length > 1) ?
                        state.insuredForms.filter((_, i) => i !== action.formIndex) :
                        state.insuredForms,
                    isInsuredFormDeletable: state.insuredForms.length > 2
                })
            )

        // TODO: Verificar Idade
        case CHANGE_INSURED_FORM_ATTR:
            const insuredForms = state.insuredForms.map((form, i) => ((i === action.formIndex) ? ({ ...form, [action.field]: action.value }) : form));

            newState = {
                ...state,
                insuredForms,
            }

            return calcCreditCard(
                updatePurchaseSummaryData({ ...newState })
            )
        // #endregion

        // #region PaymentMethods
        case FETCH_PAYMENT_METHODS:
            action.paymentMethods.creditcard.brands[0].selected = true;

            if (action.extra.cookies && state.userDetails.authenticated)
                Object.keys(action.extra.cookies).forEach(
                    cookie => {
                        if (!cookie.startsWith('pcrid'))
                            removeCookie(cookie)
                    }
                )
            const payments = []

            for (let i = 0; i < state.paymentMethods.length; i++) {
                if (state.paymentMethods[i].active) {
                    if (state.paymentMethods[i].slug === 'credit-card') {
                        payments.push({ ...state.paymentMethods[i] })
                        continue
                    }
                    else if (state.paymentMethods[i].slug === 'boleto') {
                        payments.push({ ...state.paymentMethods[i], available: action.paymentMethods.boleto.available })
                    }
                    else if (state.paymentMethods[i].slug === 'safetypay') {
                        payments.push({ ...state.paymentMethods[i], available: action.paymentMethods.safetypay.available })
                    }
                    else if (state.paymentMethods[i].slug === 'cash') {
                        payments.push({ ...state.paymentMethods[i], available: true })
                        continue
                    }
                    else if (state.paymentMethods[i].slug === 'pix') {
                        payments.push({ ...state.paymentMethods[i], available: true })
                        continue
                    }

                    state = setNotAvailableAlert(state, state.paymentMethods[i])
                }
            }

            const data = {
                ...state,
                boleto: {
                    ...state.boleto,
                    available: action.paymentMethods.boleto.available,
                    min_value: action.paymentMethods.boleto.min_value,
                },
                safetypay: {
                    ...state.safetypay,
                    banks: action.paymentMethods.safetypay.banks,
                    available: action.paymentMethods.safetypay.available,
                    min_value: action.paymentMethods.safetypay.min_value,
                },
                creditCard: {
                    ...state.creditCard,
                    available: action.paymentMethods.creditcard.available,
                    baseBrands: action.paymentMethods.creditcard.brands,
                },
            }

            return calcCreditCard(
                updatePurchaseSummaryData(data)
            )

        case SELECT_PAYMENT_METHOD:

            //Datalayer
            var paymentMethod = ""
            switch (action.methodIndex) {
                case 0:
                    paymentMethod = "pix"
                    break;
                case 1:
                    paymentMethod = "boleto"
                    break;
                case 2:
                    paymentMethod = "cartao_de_credito"
                    break;
                case 3:
                    paymentMethod = "tranferencia"
                    break;
            }

            dataLayer.raw({ event: 'selecao_meio_pagamento', meio_pagamento: paymentMethod });

            // Matomo tracking
            matomoTracker.trackEvent('Checkout', 'ChangePayment', paymentMethod);

            const fetchState = {
                ...state,
                stepDisplayMethodPayment: action.stepDisplayMethodPayment,
                paymentMethods: (
                    state.paymentMethods.map(
                        (method, index) => ({ ...method, selected: (index === action.methodIndex) })
                    )
                ),
                alert: '',
            };

            const NewState = calcCreditCard(updatePurchaseSummaryData(fetchState))

            if (!NewState.paymentMethods[action.methodIndex].available)
                return {
                    ...state,
                    paymentMethods: (
                        state.paymentMethods.map(
                            (method, index) => ({ ...method, selected: (index === action.methodIndex) })
                        )
                    ),
                    alert: state.paymentMethods[action.methodIndex].slug,
                }

            return calcCreditCard(
                updatePurchaseSummaryData(NewState)
            );

        // #endregion

        // #region CreditCard
        case SELECT_CREDITCARD_BRAND:
            const brands = state.creditCard.brands.map(
                (brand, i) => ({ ...brand, selected: (action.brand_index === i) })
            )

            const regexEmpty = new RegExp(' ', 'g');
            const brandSelected = brands.filter(brand => brand.selected)[0]
            let creditCardNumber = state.creditCard.number.replace(regexEmpty, '')

            if (brandSelected.brand_name === 'amex' && creditCardNumber.length > 15)
                creditCardNumber = state.creditCard.number.slice(0, 15 - creditCardNumber.length)
            else if (brandSelected.brand_name === 'diners' && creditCardNumber.length > 14)
                creditCardNumber = state.creditCard.number.slice(0, 14 - creditCardNumber.length)
            else creditCardNumber = state.creditCard.number

            return calcCreditCard({
                ...state,
                creditCard: {
                    ...state.creditCard,
                    number: creditCardNumber,
                    brands,
                }
            })
        case SELECT_CREDITCARD_PARCEL:
            return {
                ...state,
                creditCard: {
                    ...state.creditCard,
                    parcels: state.creditCard.parcels.map(
                        (parcel, i) => ({ ...parcel, selected: (parseInt(action.parcel_index, 10) === i) })
                    )
                },
                errors: {
                    ...state.errors,
                    creditCard: {
                        ...state.errors.creditCard,
                        parcels: false
                    }
                }
            };
        case CHANGE_CREDITCARD_ATTR:
            return {
                ...state,
                creditCard: {
                    ...state.creditCard,
                    [action.field]: action.value
                }
            };
        // #endregion

        // #region Boleto
        case CHANGE_BOLETO_ATTR:
            return {
                ...state,
                boleto: {
                    ...state.boleto,
                    [action.field]: action.value,
                }
            }
        // #endregion

        // #region safetypay
        case SELECT_BANK:
            return {
                ...state,
                safetypay: {
                    ...state.safetypay,
                    banks: (
                        state.safetypay.banks.map((bank, index) => ({ ...bank, selected: (index === action.bankIndex) }))
                    )
                },
                errors: {
                    ...state.errors,
                    safetypay: {
                        ...state.errors.safetypay,
                        banks: false
                    }
                }
            };
        case CHANGE_SAFETYPAY_ATTR:
            return {
                ...state,
                safetypay: {
                    ...state.safetypay,
                    [action.field]: action.value
                }
            };
        // #endregion

        // #region Cash
        case CHANGE_CASH_ATTR:
            return {
                ...state,
                cash: {
                    ...state.cash,
                    [action.field]: action.value
                }
            };
        // #endregion

        // #region Cash
        case CHANGE_PIX_ATTR:
            return {
                ...state,
                pix: {
                    ...state.pix,
                    [action.field]: action.value
                }
            };
        // #endregion

        // #region Contact
        case CHANGE_CONTACT_ATTR:
            return {
                ...state,
                contact: {
                    ...state.contact,
                    [action.field]: action.value
                }
            };
        // #endregion

        case FETCH_BENEFITS_METHODS:
            return {
                ...state,
                benefits_list: action.benefits
            };

        case FETCH_PLANS:
            if (action.context !== 'purchase')
                return { ...state }

            newState = {
                ...state,
                plans: action.plans,
                filtered_plans: action.plans,
            }
            return calcCreditCard(
                updatePurchaseSummaryData({
                    ...newState,
                })
            );
        case FETCH_PLANS_PURCHASE:
            return {
                ...state,
                plans: action.plans,
                filtered_plans: action.plans,
            }
        case FINISH_PURCHASE:
            newState = validatePurchase(state);

            if (newState.purchase_is_valid) {
                checkoutPurchase(newState);
            } else
                newState.loading = false;

            return newState;

        case SET_QUOTATION_PARAMS:
            return {
                ...state,
                quotationParams: {
                    departure_date: action.departure_date,
                    return_date: action.return_date,
                    destination: action.destination,
                    product_code: action.product_code,
                    queryParams: action.queryParams,
                },
            }
        case SET_PARTNER:
            return {
                ...state,
                partner: action.partner
            };
        case SET_PURCHASE_UUID:
            return {
                ...state,
                uuid: action.uuid
            }
        case VALIDATE_PURCHASE:
            return {
                ...state,
                purchaseIsValid: action.purchaseIsValid,
                status: action.status
            };
        case FETCH_ADDRESS:
            return {
                ...state,
                contact: {
                    ...state.contact,
                    state: action.state,
                    city: action.city,
                    district: action.district,
                    address: action.address,
                },
                errors: {
                    ...state.errors,
                    contact: {
                        ...state.errors.contact,
                        state: false,
                        city: false,
                        district: false,
                        address: false,
                    }
                }
            };
        case CLEAR_ALERTS:
            return {
                ...state,
                alert: '',
            }
        case START_PURCHASE_LOADING:
            return {
                ...state,
                loading: true
            }
        case END_PURCHASE_LOADING:
            return {
                ...state,
                loading: false
            }
        case OPEN_DETAIL_MODAL:
            return {
                ...state,
                isModalDetailActive: true,
            }
        case CLOSE_DETAIL_MODAL:
            return {
                ...state,
                isModalDetailActive: false,
            }
        case OPEN_MODAL_PURCHASE_ERROR:
            return {
                ...state,
                isModalPurchaseErrorActive: true,
            }
        case CLOSE_MODAL_PURCHASE_ERROR:
            return {
                ...state,
                isModalPurchaseErrorActive: false,
            }
        case OPEN_MODAL_COUPON_ERROR:
            return {
                ...state,
                isModalCouponErrorActive: true,
            }
        case CLOSE_MODAL_COUPON_ERROR:
            return {
                ...state,
                isModalCouponErrorActive: false,
            }
        case OPEN_MODAL_PURCHASE_DATE_ERROR:
            return {
                ...state,
                isModalPurchaseErrorDate: true,
            }
        case CLOSE_MODAL_PURCHASE_DATE_ERROR:
            return {
                ...state,
                isModalPurchaseErrorDate: false,
            }
        case OPEN_MODAL_GENERIC_ERROR:
            return {
                ...state,
                isModalGenericErrorActive: true,
            }
        case CLOSE_MODAL_GENERIC_ERROR:
            return {
                ...state,
                isModalGenericErrorActive: false,
            }
        case OPEN_MODAL_FRANCHISE:
            return {
                ...state,
                isModalFranchiseActive: true,
            }
        case CLOSE_MODAL_FRANCHISE:
            return {
                ...state,
                isModalFranchiseActive: false,
            }
        case OPEN_MODAL_OPERATOR_CONFIRMATION:
            return {
                ...state,
                isModalOperatorConfirmationActive: true,
            }
        case CLOSE_MODAL_OPERATOR_CONFIRMATION:
            return {
                ...state,
                isModalOperatorConfirmationActive: false,
            }
        case OPEN_MODAL_NOT_COVID_COVERAGE:
            return {
                ...state,
                isModalNotCovidCoverage: true,
            }
        case CLOSE_MODAL_NOT_COVID_COVERAGE:
            return {
                ...state,
                isModalNotCovidCoverage: false,
            }
        case OPEN_MODAL_STUDENT:
            return {
                ...state,
                isModalStudentActive: true,
            }
        case CLOSE_MODAL_STUDENT:
            return {
                ...state,
                isModalStudentActive: false,
            }
        case OPEN_MODAL_SAFETYPAY:
            return {
                ...state,
                isModalSafetypayActive: true,
            }
        case CLOSE_MODAL_SAFETYPAY:
            return {
                ...state,
                isModalSafetypayActive: false,
            }
        case OPEN_MODAL_TERMS_OF_USE:
            return {
                ...state,
                isModalTermsOfUseActive: true,
            }
        case CLOSE_MODAL_TERMS_OF_USE:
            return {
                ...state,
                isModalTermsOfUseActive: false,
            }

        case OPEN_MODAL_TRAVEL_RENEWAL:
            return {
                ...state,
                isModalTravelRenewalActive: true,
            }

        case CLOSE_MODAL_TRAVEL_RENEWAL:
            return {
                ...state,
                isModalTravelRenewalActive: false,
            }
        case OPEN_MODAL_RENEWAL_FRANCHISE:
            return {
                ...state,
                isModalRenewalFranchiseActive: true,
            }

        case CLOSE_MODAL_RENEWAL_FRANCHISE:
            return {
                ...state,
                isModalRenewalFranchiseActive: false,
            }

        case OPEN_MODAL_RECEPTIVE_PRODUCT:
            return {
                ...state,
                isModalReceptiveProductActive: true,
            }
        case CLOSE_MODAL_RECEPTIVE_PRODUCT:
            return {
                ...state,
                isModalReceptiveProductActive: false,
            }
        case OPEN_MODAL_PLAN_RULES:
            return {
                ...state,
                isModalPlanRulesActive: true,
            }
        case OPEN_MODAL_FAIL_PAYMENT:
            return {
                ...state,
                isModalFailPayment: true,
            }
        case CLOSE_MODAL_PLAN_RULES:
            return {
                ...state,
                isModalPlanRulesActive: false,
            }
        case CLOSE_MODAL_FAIL_PAYMENT:
            return {
                ...state,
                isModalFailPayment: false,
            }
        case HIDE_INVALID_CREDIT_CARD_ERROR:
            return {
                ...state,
                isInvalidCreditCardErrorVisible: false,
                invalidCreditCard: {
                    brand: '',
                    lastDigits: ''
                },
            }
        case SHOW_INVALID_CREDIT_CARD_ERROR:
            const brand = state.creditCard.brands.find(b => b.selected).brand_name
            let lastDigits = state.creditCard.number.slice(-4)
            if (brand === 'amex')
                lastDigits = state.creditCard.number.slice(-5)

            return {
                ...state,
                isInvalidCreditCardErrorVisible: true,
                invalidCreditCard: {
                    brand,
                    lastDigits
                },
                stagePurchase: 2,
                stepDisplayCreditCard: 3,
            }

        case FETCH_PURCHASE_DATA:
            /* eslint no-case-declarations:0 */
            const isInsuredFormDeletable = action.data.insureds.length > 2;

            return calcCreditCard(
                updatePurchaseSummaryData({
                    ...state,
                    insuredForms: [
                        ...action.data.insureds.map(
                            (insured) => (
                                {
                                    rg: '',
                                    cpf: insured.cpf,
                                    name: insured.full_name,
                                    birth_date: formatDate(insured.birth_date),
                                    document_type: 'cpf',
                                }
                            ),
                        ),
                    ],
                    creditCard: {
                        ...state.creditCard,
                        holder_name: action.data.holder.full_name,
                        holder_cpf: action.data.holder.cpf,
                    },
                    boleto: {
                        ...state.boleto,
                        name: action.data.holder.full_name,
                        cpf: action.data.holder.cpf
                    },
                    safetypay: {
                        ...state.safetypay,
                        cpf: action.data.holder.cpf,
                        name: action.data.holder.full_name,
                    },
                    isInsuredFormDeletable
                })
            );
        case SET_USER_DETAILS:
            return {
                ...state,
                userDetails: action.userDetails
            }
        case CHANGE_CONFIRM_TERMS:
            return {
                ...state,
                dateTimeAccept: action.dateTimeAccept
            }
        case CLEAN_ERRORS:
            return {
                ...state,
                errors: cleanStateErrors()
            }
        case NEXT_STAGE_PURCHASE_MOBILE:
            newState = validatePurchaseMobile(state, action.stageValidator)
            if (newState.purchase_is_valid) {
                if (action.stageValidator === 'INSURED_RESP_CONTACT') {
                    return {
                        ...newState,
                        stagePurchase: action.index,
                        stepPaymentFinish: true
                    }
                }

                return {
                    ...newState,
                    stagePurchase: action.index
                }
            }

            return newState

        case STAGE_PAYMENT_CREDIT_CARD:
            return {
                ...state,
                stepDisplayCreditCard: action.stepDisplayCreditCard
            }
        case STAGE_PAYMENT_CASH_TRANSFER:
            return {
                ...state,
                stepDisplayCashTransfer: action.stepDisplayCashTransfer
            }
        case EDIT_PURCHASE:
            if (action.stagePurchase === 2) {
                return {
                    ...state,
                    stagePurchase: action.stagePurchase,
                    stepDisplayMethodPayment: 0,
                    stepDisplayCreditCard: 0,
                    stepDisplayCashTransfer: 0,
                    stepDisplayBoleto: 0,
                    stepDisplayPix: 0,
                }
            }

            return {
                ...state,
                stagePurchase: action.stagePurchase
            }
        case BACK_STAGE_PURCHASE:
            if (action.stagePurchase === 4) {
                return {
                    ...state,
                    stagePurchase: action.stagePurchase - 1,
                    stepPaymentFinish: false
                }
            }
            return {
                ...state,
                stagePurchase: action.stagePurchase - 1
            }
        case SELECT_PAYMENT_ALTER_STATE:
            return {
                ...state,
                [action.name]: action.index
            }
        case BACK_STAGE_PAYMENT_METHOD:
            if (action.condition) {
                const PaymentMethods = state.paymentMethods

                PaymentMethods.map((method, i) => {
                    if (method.selected === true) {
                        PaymentMethods[i] = {
                            ...method,
                            selected: false,
                        }
                    }
                    return state
                })

                return updatePurchaseSummaryData(
                    {
                        ...state,
                        [action.name]: action.index,
                        PaymentMethods,
                        stepDisplayMethodPayment: 0,
                        purchaseSummary: {
                            ...state.purchaseSummary,
                            paymentMethodDiscountPercent: 0,
                            paymentMethodDiscountValue: 0,
                            paymentMethodSelected: '',
                        }
                    }
                )
            }
            return {
                ...state,
                [action.name]: action.index
            }
        case CLEAN_STATES_PURCHASE_MOBILE: {
            return {
                ...state,
                stagePurchase: 1,
                stepDisplayMethodPayment: 0,
                stepDisplayCreditCard: 0,
                stepDisplayCashTransfer: 0,
                stepDisplayBoleto: 0,
                stepDisplayPix: 0,
            }
        }
        case VALIDATOR_HANDLER_BLUR:
            const errors = validatePurchaseOnBlur(action.value, action.name, action.index, state)
            return {
                ...state,
                errors,
            }
        case GET_INFOS_PROSPECT:
            if (action.infos) {
                return {
                    ...state,
                    prospect: action.infos
                }
            }
            return state
        case SET_INFOS_PROSPECT_IN_PURCHASE:
            if (state.prospect.exist) {
                const insuredForms = state.insuredForms.map((form, i) => ((form.id === 0) ? ({ ...form }) : form));

                return {
                    ...state,
                    insuredForms,
                    contact: {
                        ...state.contact,
                        contact_name: state.prospect.name,
                        email: state.prospect.email,
                        phone_number: state.prospect.phone,
                    }
                }
            }
            return state
        case CLEAR_INFOS_PROSPECT:
            return {
                ...state,
                contact: {
                    ...state.contact,
                    contact_name: '',
                    email: '',
                    phone_number: ''
                }
            }
        case SET_BENEFITS:
            return {
                ...state,
                benefits: [...action.benefits]
            }
        case GET_INFOS_INSUREDS:
            if (action.payment === 1) {
                return {
                    ...state,
                    boleto: {
                        ...state.boleto,
                        name: state.insuredForms[0].name,
                        cpf: state.insuredForms[0].cpf
                    }
                }
            } else if (action.payment === 3) {
                return {
                    ...state,
                    safetypay: {
                        ...state.safetypay,
                        name: state.insuredForms[0].name,
                        cpf: state.insuredForms[0].cpf
                    }
                }
            } else if (action.payment === 4) {
                return {
                    ...state,
                    pix: {
                        ...state.pix,
                        name: state.insuredForms[0].name,
                        cpf: state.insuredForms[0].cpf
                    }
                }
            }
            return state;
        case SET_OPERATOR_CONFIRMATION_CLICKED:
            return {
                ...state,
                hasConfirmedOperator: true
            };
        case SET_UPSELL_PURCHASE:
            return {
                ...state,
                upsellUpgrade: action.upsellProduct
            }
        default:
            return state;
    }
};

export default purchase;



// WEBPACK FOOTER //
// ./src/reducers/purchaseReducer.js